import React from "react";

/**
 * Shared activity row for all member detail tabs.
 */
export default function UserSurfaceRow({
  rank,
  initials,
  name,
  tags = [],
  context,
  metrics,
  accent,
}) {
  return (
    <article className={`au-surface-row${accent ? ` au-surface-row-${accent}` : ""}`}>
      <span className="au-surface-rank">{String(rank).padStart(2, "0")}</span>
      <span className="au-surface-avatar" aria-hidden>
        {initials}
      </span>
      <div className="au-surface-body">
        <div className="au-surface-top">
          <span className="au-surface-name" title={name}>
            {name}
          </span>
          {tags.map((tag) => (
            <span
              key={`${tag.label}-${tag.tone}`}
              className={`au-surface-tag au-surface-tag-${tag.tone || "muted"}`}
            >
              {tag.label}
            </span>
          ))}
        </div>
        {context ? <p className="au-surface-sub">{context}</p> : null}
        {metrics ? <p className="au-surface-meta">{metrics}</p> : null}
      </div>
    </article>
  );
}

export function UserSurfaceRowSkeleton() {
  return (
    <div className="au-surface-row au-surface-row-skeleton" aria-hidden>
      <span className="au-surface-rank" />
      <span className="au-surface-avatar" />
      <span className="au-surface-body">
        <span className="au-surface-skeleton-line au-surface-skeleton-line-lg" />
        <span className="au-surface-skeleton-line" />
      </span>
    </div>
  );
}
